import React from 'react';
import { Link } from 'react-router-dom';

import { Button } from 'antd';
import { 
  RocketOutlined
} from '@ant-design/icons';

import bgVideo from '../../vid/lux.mp4';

import { 
	VideoContainer,
  BgVideo, 
  Overlay
 } from "./video-background.styles";


const VideoBackground = () => {
  return (
    <VideoContainer>
      {/* Background Video */}
      <BgVideo autoPlay muted loop>
        <source src={bgVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </BgVideo>
      
      {/* Overlay Box */}
      <Overlay>
        <h1><span>Empowering</span><br/><span>Your eCommerce</span><br/><span>Journey</span></h1>
        <div className='buttext-container'>
          <span className='buttext-box'>
            <p>Discover why your store isn't <br/>selling and the simple fixes.</p>
            <Link style={{
                textDecoration: 'inherit',
                // backgroundColor: 'red',
                width: '100%',
                display: 'flex',
                justifyContent: `${window.screen.width <= 1000 ? 'center' : 'flex-start'}`,
              }}
              to='../free-audit'
              // onClick={toMail}
            >
              <Button 
                block={true}
                // size='large' 
                style={{
                  fontFamily: 'Georgia, serif',
                  fontSize: `${window.screen.width <= 1000 ? '1.1em' : '1.5em'}`,
                  fontWeight: 'bold',
                  // margin: '0.5em 0 0 0',
                  padding: '0.5rem 2rem 0.5rem 2rem',
                  maxWidth: `${window.screen.width <= 1000 ? '98%' : 'max-content'}`,
                  height: 'auto',
                  // alignSelf: 'center'
                }}
              >Free Audit</Button>
            </Link>
          </span>
          <Link style={{
                color: 'white',
                textDecoration: 'inherit',
                fontFamily: 'Georgia, serif',
                fontSize: `${window.screen.width <= 1000 ? '1.1em' : '1.4em'}`,
                // margin: '0.5em 0 0 0',
                padding: '0.5rem 2rem 0.5rem 2rem',
                maxWidth: `${window.screen.width <= 1000 ? '98%' : '500px'}`,
                height: 'auto',
                alignSelf: 'center'
              }}
              to='../launch-store'
            ><RocketOutlined/> Launch a new store</Link>
        </div>
        
      </Overlay>
    </VideoContainer>
  );
};

export default VideoBackground;